import { NgModule } from '@angular/core';

import { Settings8021xApiService } from '../api';

import { SysApi8021xApiService } from './sys-api-8021x-api.service';

@NgModule({
	providers: [
		SysApi8021xApiService,
		{
			provide: Settings8021xApiService,
			useClass: SysApi8021xApiService
		}
	]
})
export class SysApi8021xDataAccessModule {}
